import { modalColor } from "src/161759/utils"
import Leaderboard from "src/components/Leaderboard"
import { userID, userName } from "src/utils/datalayer"
import { ModalWrapper } from "src/utils/fw"

export default () => {
    return <ModalWrapper wrapperStyle={{backgroundColor: modalColor}}>
        <Leaderboard  
            userId={userID}
            eventId="161759"
            name={userName}
            entrypoint="https://leaderboardb.swoogo-retrofit.tkevents.io"
            poolingSec={3}
            hideClose={true}
            floating={false}
            hideButtons={true}
        />
    </ModalWrapper>
}